import React from 'react';
import { Phone, Mail, MapPin, ExternalLink } from 'lucide-react';
import { companyInfo } from '../data/mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const services = [
    'Web Application Development',
    'Mobile App Development', 
    'Enterprise Software Solutions',
    'E-commerce Development',
    'UI/UX Design',
    'Cloud Solutions'
  ];

  const quickLinks = [
    { name: 'About Us', href: '#about' },
    { name: 'Services', href: '#services' },
    // { name: 'Projects', href: '#projects' },
    // { name: 'Team', href: '#team' },
    { name: 'Contact', href: '#contact' }
  ];

  return (
    <footer className="bg-black text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="lg:col-span-1">
            <div className="flex items-center space-x-3 mb-6">
              <img 
                src="https://customer-assets.emergentagent.com/job_e04a7c5b-08b4-48c2-8ec6-0f4103eb451f/artifacts/pl201w8l_Screenshot_2025-06-21_133545-removebg-preview.png" 
                alt="MYLKSYSTEMS Logo" 
                className="h-8 w-auto"
              />
              {/* <span className="text-xl font-bold tracking-wide">MYLKSYSTEMS</span> */}
            </div>
            <p className="text-gray-400 leading-relaxed mb-6">
              {companyInfo.tagline}
            </p>
            <div className="space-y-3">
              <div className="flex items-center space-x-3">
                {/* <Phone className="h-5 w-5 text-yellow-600" /> */}
                <a 
                  href={`tel:${companyInfo.phone}`}
                  className="text-gray-400 hover:text-white transition-colors duration-200"
                >
                  {companyInfo.phone}
                </a>
              </div>
              <div className="flex items-center space-x-3">
                <Mail className="h-5 w-5 text-yellow-600" />
                <a 
                  href={`mailto:${companyInfo.email}`}
                  className="text-gray-400 hover:text-white transition-colors duration-200"
                >
                  {companyInfo.email}
                </a>
              </div>
              <div className="flex items-start space-x-3">
                <MapPin className="h-5 w-5 text-yellow-600 mt-1" />
                <span className="text-gray-400">
                  {companyInfo.address}
                </span>
              </div>
            </div>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-semibold mb-6">Our Services</h3>
            <ul className="space-y-3">
              {services.map((service, index) => (
                <li key={index}>
                  <a 
                    href="#services" 
                    className="text-gray-400 hover:text-white transition-colors duration-200 text-sm"
                  >
                    {service}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-6">Quick Links</h3>
            <ul className="space-y-3">
              {quickLinks.map((link, index) => (
                <li key={index}>
                  <a 
                    href={link.href} 
                    className="text-gray-400 hover:text-white transition-colors duration-200 text-sm"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
            
            <div className="mt-8">
              <h4 className="text-md font-semibold mb-4">Business Hours</h4>
              <div className="space-y-2 text-sm text-gray-400">
                <div>Monday - Friday: 9:00 AM - 6:00 PM</div>
                <div>Saturday: 9:00 AM - 2:00 PM</div>
                <div>Sunday: Closed</div>
              </div>
            </div>
          </div>

          {/* Newsletter/CTA */}
          <div>
            <h3 className="text-lg font-semibold mb-6">Stay Connected</h3>
            <p className="text-gray-400 text-sm leading-relaxed mb-6">
              Get updates on our latest projects and technology insights.
            </p>
            
            <div className="space-y-4">
              <button 
                className="w-full bg-yellow-600 hover:bg-yellow-700 text-black font-semibold px-4 py-3 rounded-lg transition-all duration-200 hover:scale-105 text-sm"
                onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
              >
                Start Your Project
              </button>
              
              {/* <button 
                className="w-full border border-gray-600 text-gray-300 hover:border-gray-400 hover:text-white px-4 py-3 rounded-lg transition-all duration-200 text-sm bg-transparent"
                onClick={() => window.open(`tel:${companyInfo.phone}`, '_self')}
              >
                Call Us Now
              </button> */}
            </div>

            <div className="mt-6">
              <h4 className="text-md font-semibold mb-4">Technologies</h4>
              <div className="flex flex-wrap gap-2">
                {['React', 'Node.js', 'Flutter', 'AWS'].map((tech, index) => (
                  <span 
                    key={index} 
                    className="text-xs bg-gray-800 text-gray-400 px-2 py-1 rounded border border-gray-700"
                  >
                    {tech}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="text-gray-400 text-sm mb-4 md:mb-0">
              © {currentYear} {companyInfo.name}. All rights reserved.
            </div>
            <div className="flex space-x-6 text-sm">
              <a href="#" className="text-gray-400 hover:text-white transition-colors duration-200">
                Privacy Policy
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors duration-200">
                Terms of Service
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors duration-200">
                Careers
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;